import { jsx as _jsx } from "react/jsx-runtime";
import { useReducer, useContext, createContext } from 'react';
import { SearchContextReducer } from './search-context-reducer';
export const getResults = async (stateSearchCriteria, brand, endpointUrl, additionalParams) => {
    const reducedSearchCriteria = Object.entries(stateSearchCriteria).reduce((a, [k, v]) => {
        if (v !== null) {
            // eslint-disable-next-line no-param-reassign
            a[k] = v;
        }
        return v === null ? a : (a[k], a);
    }, {});
    const urlParameters = new URLSearchParams({
        ...reducedSearchCriteria,
        ...additionalParams,
    });
    if (!urlParameters.has('brand')) {
        urlParameters.set('brand', brand);
    }
    return (await fetch(`${endpointUrl}?${urlParameters.toString()}`)).json();
};
export const SearchContextState = createContext(undefined);
const SearchContextDispatch = createContext(undefined);
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function useSearchContextDispatch() {
    const { dispatch } = useContext(SearchContextDispatch);
    if (dispatch === undefined) {
        throw new Error('useSearchContextDispatch must be used within a SearchContext container');
    }
    return dispatch;
}
export function useSearchContextState() {
    const state = useContext(SearchContextState);
    if (state === undefined) {
        throw new Error('SearchContextState must be used within a SearchContext container');
    }
    return state;
}
function SearchContext({ children, searchCriteria, }) {
    const [state, dispatch] = useReducer(SearchContextReducer, {
        loading: true,
        totalSelectedFilters: 0,
        searchCriteria,
    });
    return (_jsx(SearchContextDispatch.Provider, { value: { dispatch }, children: _jsx(SearchContextState.Provider, { value: state, children: children }) }));
}
export { SearchContext };
//# sourceMappingURL=search-context.js.map